import React from "react";
import { Line, Text, Circle } from "react-konva";
import {
  xPlacement,
  yPlacement,
  calculateDistance,
  rotation
} from "./function";
import { useSelector } from "react-redux";

export default function PolygonDraw({ points}) {
  const roofInfo = useSelector((state) => state.roof)
  const gridInfo = useSelector((state) => state.grid)

  const view = roofInfo.value.mapOption.mapTypeId;

  return points.map((point, index) => (
    <React.Fragment key={index}>
      {index > 0 && (
        <Line
          points={[points[index - 1].x, points[index - 1].y, point.x, point.y]}
          stroke="black"
        />
      )}
      <Circle x={point.x} y={point.y} radius={4} fill="red" />
      {index > 0 && (
        <Text
          x={xPlacement(points[index - 1], point, points)}
          y={yPlacement(points[index - 1], point, points)}
          rotation={rotation(points[index - 1], point)}
          fontFamily="italic"
          fontSize={14}
          fill={view === "satellite" ? "white" : "red"}
          strokeWidth={1}
          align="center"
          text={`${calculateDistance(points[index - 1], point, roofInfo, gridInfo)}`}
        />
      )}
    </React.Fragment>
  ));
}
